// extracted by mini-css-extract-plugin
module.exports = {"rarity":"WearableRarity_rarity__3y2iN"};